import { Component } from '@angular/core';

@Component({
    selector: 'app-lookups',
    templateUrl: './lookups.component.html'
})
export class LookupsComponent{
}